module.exports = __webpack_public_path__ + "static/media/img-7.66001cf8.jpg";